
import React from 'react';
import { MdOutlineCall, MdOutlineMail } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";

const JobCard = ({ job }) => {

  const whatsappMessage = encodeURIComponent(
    `Hello, I am interested in the ${job.title} position at ${job.company}. Could you please provide more information?`
  );
  

  const emailSubject = encodeURIComponent(`Inquiry about ${job.title} position`);
  const emailBody = encodeURIComponent(
    `Hello,\n\nI would like to know more about the ${job.title} position at ${job.company}.\n\nThank you!`
  );

  return (
    <div className='bg-white shadow-md rounded-md border-l-4 border-teal-500 p-3 flex flex-col lg:flex-row justify-between items-center gap-4 mb-6 cursor-pointer'>
      <div className='flex flex-col items-start lg:flex-row lg:justify-center gap-4 w-full lg:w-auto'>
        <img src={`${process.env.REACT_APP_POCKETBASE_URL}/api/files/${job.collectionId}/${job.id}/${job.logo}`} alt={job.title} className='w-30 h-40 ' />
        <div>
          <div className='flex items-center gap-2'>
            <h3 className='text-teal-700 font-bold'>{job.company}</h3>
            {job.new && (
              <span className='bg-teal-500 text-white text-xs px-2 py-1 mb-1 rounded-full uppercase tracking-wide font-semibold'>
                NEW!
              </span>
            )}
            {job.featured && (
              <span className='bg-gray-800 text-white text-xs px-2 py-1 mb-1 rounded-full uppercase tracking-wide font-semibold'>
                FEATURED
              </span>
            )}
          </div>
          <h2 className='text-lg font-bold text-gray-800 hover:text-teal-600 cursor-pointer'>
            {job.title}
          </h2>
          <div className='text-sm text-gray-500 mt-1'>
            {job.postedAt} • {job.contract} • {job.location}
          </div>
        </div>
      </div>
      <div className='flex flex-wrap justify-start lg:justify-end gap-2 mt-0 lg:mt-0 w-full lg:w-auto'>
        <div className='grid grid-cols-2 gap-1 w-full lg:w-auto lg:grid-cols-3'>
          <a 
            href={`tel:${job.phoneNumber}`} 
            className="text-blue-500 no-underline hover:underline inline-flex items-center gap-1"
          >
            <MdOutlineCall /> {job.phoneNumber}
          </a>
          <a 
            href={`https://wa.me/+94${job.whatsappNumber}?text=${whatsappMessage}`} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-green-500 hover:underline no-underline inline-flex items-center gap-1"
          >
            <FaWhatsapp /> WhatsApp
          </a>
          <a 
            href={`mailto:${job.email}?subject=${emailSubject}&body=${emailBody}`} 
            className="text-red-500 hover:underline no-underline normal-case inline-flex items-center gap-1"
          >
            <MdOutlineMail /> {job.email}
          </a>
        </div>
        {job.tags && job.tags.map((tag, idx) => (
          <span
            key={idx}
            className='bg-teal-100 text-teal-700 px-3 py-1 text-sm font-semibold rounded'
          >
            {tag}
          </span>
        ))}
      </div>
    </div>
  );
};

export default JobCard;
